import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles(theme => ({
  form: {
    marginBottom: theme.spacing(2)
  },
  tabs: {
    marginTop: theme.spacing(2)
  }
}));
